import { useState } from "react"
import { useAsyncEffect } from "./useAsyncEffect"

export function usePromiseResolver<T>(
  promise: () => Promise<T> | T,
  updatesOn: any[] = [],
): null | T {
  const [value, setValue] = useState<T | null>(null)

  useAsyncEffect(async () => {
    const value = await promise()
    setValue(value)
  }, updatesOn)

  return value
}
